import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  exceptionAlertModalTitle: {
    defaultMessage: 'Local Delivery Exception',
    id: '4rvSfI',
    description: 'Local Delivery Exception Alert Modal Title',
  },
  singleShipmentExceptionAlertModalBody: {
    defaultMessage:
      'An issue was detected with your {carrierName} delivery for Order {orderLink}. Please contact {carrierName} support via phone or via email {email}',
    id: 'IiVbfA',
    description: 'Local Delivery Exception Alert Modal Body',
  },
  multiShipmentExceptionAlertModalBody: {
    defaultMessage:
      'An issue was detected with your {carrierName} delivery for Shipment {shipmentLink} on Order {orderLink}. Please contact {carrierName} support via phone or via email {email}',
    id: 'XFqrFm',
    description: 'Local Delivery Exception Alert Modal Body',
  },
});
